import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {LinkSchema} from './link'
import {AssetSchema} from './asset'
import {RichTextSchema} from '../richText'
import {safeOptional} from '../../safe-optional'

export const PrimerComponentBreakoutBannerSchema = buildEntrySchemaFor('primerComponentBreakoutBanner', {
  fields: z.lazy(() =>
    z.object({
      align: z.enum(['start', 'center']),
      backgroundColor: z.enum(['default', 'subtle']).optional(),
      backgroundImage: safeOptional(AssetSchema),
      ctaLink: LinkSchema,
      heading: RichTextSchema,
      headingLevel: z.enum(['h2', 'h3', 'h4', 'h5', 'h6']).optional(),
      logo: z.string().optional(),
    }),
  ),
})

export type PrimerComponentBreakoutBanner = z.infer<typeof PrimerComponentBreakoutBannerSchema>
